
import { FieldControl } from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class UsersAutocomplete extends SelectField {

    controlType = FieldControl.USERS_AUTOCOMPLETE;
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] ? options['type'].toLowerCase(): 'text';
    }

}
